export const EnvironmentIcon = () => {
  return (
    <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16.5 1.71857V10.2818C16.5 10.63 16.154 10.8753 15.8238 10.7644C14.4548 10.3048 11.2905 9.3335 9 9.3335C6.70948 9.3335 3.54522 10.3048 2.17616 10.7644C1.84602 10.8753 1.5 10.63 1.5 10.2818V1.71857C1.5 1.37032 1.84602 1.12507 2.17616 1.2359C3.54522 1.69551 6.70948 2.66683 9 2.66683C11.2905 2.66683 14.4548 1.69551 15.8238 1.2359C16.154 1.12507 16.5 1.37032 16.5 1.71857Z" stroke="current" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}
